<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>编辑限制规则</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
                <el-col :span="12">
                    <sub-form v-if="loginRule != null && loginRule.id > 0" :model="loginRule" scenario="update"></sub-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import subForm from "~/views/login-rules/form.vue"
    import {LoginRuleService} from "~/services/LoginRule"

    export default {
        name: "update",
        components: {
            subForm
        },
        data() {
            return {
                loginRule: null
            }
        },
        created() {
            this.getLoginRule(this.$route.query["id"]);
        },

        methods: {
            getLoginRule(id) {
                if (parseInt(id) > 0) {
                    LoginRuleService.getInfo(id).then(res => {
                        if (res.code == 0) {
                            let model = res.data;
                            this.loginRule = {
                                id: parseInt(model.id),
                                type: parseInt(model.type),
                                allow_range: model.allow_range,
                                allow_times: model.allow_times,
                                allow_ips: model.allow_ips
                            }
                        }
                    })
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/login-rules/update.vue